import { useState, useMemo, createContext } from 'react';

export const initialDataState = {};
export const DataContext = createContext(initialDataState);

export const DataProvider = ({ children }) => {
  const [dataState, setDataState] = useState(initialDataState);

  // Memoize context value for performance
  const contextValue = useMemo(
    () => ({
      dataState,
      setDataState,
    }),
    [dataState]
  );

  return <DataContext.Provider value={contextValue}>{children}</DataContext.Provider>;
};
